<template>
  <v-dialog v-model="dialogStatus"
            persistent
            max-width="700px">
    <div class="fill-height">


      <v-card class="fill-height">

        <v-card-subtitle>تعریف/ویرایش شخص</v-card-subtitle>
        <v-spacer/>
        <v-card-text>


          <v-form ref="form" @submit.prevent="save" lazy-validation v-model="valid">
            <v-row>

              <v-col
                  cols="12"
                  sm="6"
              >

                <v-text-field
                    label="نام کامل "
                    outlined
                    dense
                    :error-messages="getError('personName')"
                    v-model="model.personName"
                />

              </v-col>

              <v-col
                  cols="12"
                  sm="6"
              >

                <v-text-field
                    label="شماره موبایل"
                    outlined
                    dense
                    :error-messages="getError('mobile')"
                    v-model="model.mobile"
                />

              </v-col>
              <v-col
                  cols="12"
                  sm="6"

              >
                <v-autocomplete

                    :items="roleItems"
                    v-model="model.roleId"
                    label="نقش"
                    @input="handleInput"
                    dense
                    outlined
                    :error-messages="getError('roleId')"
                    auto-select-first append-icon="mdi-menu-down"

                />
              </v-col>
              <v-col
                  cols="12"
                  sm="6"

              >
                <v-autocomplete
                    :items="buildingList"
                    v-model="model.buildingIds"
                    label="انتخاب مجتمع"
                    @input="handleInput"
                    dense
                    multiple
                    outlined
                    :error-messages="getError('buildingIds')"
                    auto-select-first append-icon="mdi-menu-down"

                >
                  <template v-slot:selection="{ item, index }">

                    <span v-if="index === 0" >{{ item.text }}</span>

                    <span
                        v-if="index === 1"
                        class="grey--text caption"
                    >
          (+{{ model.buildingIds.length - 1 }} دیگر)
        </span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col
                  cols="12"
                  sm="6"

              >
                <v-autocomplete
                    :items="userTypeItems"
                    v-model="model.userType"
                    label="انتخاب نوع کاربر"
                    @input="handleInput"
                    dense

                    outlined
                    :error-messages="getError('userType')"
                    auto-select-first append-icon="mdi-menu-down"

                />
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  v-if="!isEdit"
              >
                <v-text-field

                    dense
                    v-model="model.passwordTemp"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    outlined
                    dir="ltr"
                    :error-messages="getError('passwordTemp')"
                    @click:append="show1 = !show1">
                  <template v-slot:label>
                    <span style="color: red;font-size:13px">*</span>
                    کلمه عبور
                  </template>
                </v-text-field>
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  v-if="!isEdit"
              >

                <v-text-field
                    dense
                    v-model="model.rePasswordTem"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    outlined
                    dir="ltr"
                    :error-messages="getError('rePasswordTem')"
                    @click:append="show1 = !show1"
                >
                  <template v-slot:label>
                    <span style="color: red;font-size:13px">*</span>
                    تکرار کلمه عبور
                  </template>
                </v-text-field>

              </v-col>
              <v-col
                  cols="12"
                  sm="6"
              >

                <v-switch dense :label="model.active?'فعال':'غیرفعال'" v-model="model.active"/>


              </v-col>
            </v-row>


            <v-divider class="p-0 m-0"/>
            <v-card-actions dir="ltr">

              <v-btn
                  small
                  depressed
                  color="primary"
                  class=" p-1 m-1"
                  type="submit"
                  :loading="loading"
              >
                ذخیره
              </v-btn>
              <v-btn
                  small
                  depressed
                  color="error"
                  class=" p-1 m-1"
                  @click="closed"
              >
                لغو
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import User_se from "./User_se";


export default {

  props: {
    dialogStatus: {
      default: false,
    },
    isEdit: {
      default: false,
    },
    model: Object,
    roleItems: Array,
    buildingList: Array,
    userTypeItems: Array,

  },
  data() {
    return {
      bindingErrors: [],
      items: [],
      valid: true,
      loading: false,
      show1: false,

    }
  },


  methods: {
    handleInput(value) {
      this.$emit('input', value)
    },
    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },
    closed() {
      this.loading = false
      this.bindingErrors = []
      this.isEdit = false
      this.$emit('update:dialogStatus', false)
      this.$root.$emit('User')
    },


    save() {
      this.loading = true
      User_se.save(this.model).then(response => {
        if (response && response.status === 200) {
          this.$snack({type: 'success'})
          this.closed()
        } else if (response && response.response.status === 400) {
          this.loading = false

          this.bindingErrors = response.response.data;
        }
      })
    },
  },


}
</script>


